export const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
export const AlphaNumericAndCharactersRegex = /^[a-zA-Z0-9-_\s?\(\).'\/]+$/;
export const AlphaNumericRegex = /^[a-zA-Z0-9\s]+$/;
export const PhoneRegex = /^(\+91\s?)?(\d{10})$/;
export const EmailRegex = /\S+@\S+\.\S+/;
